import {
  toResponseError,
  type QuizQuestionAddInput,
  type QuizQuestionAddSuccess,
  type QuizQuestionData,
} from '@terros/common'
import { useQuizCache } from '../cache'
import { useTantalimMutation } from '../../mutation'
import { mutationAdd, type AddHookResponse } from '../../hooks'

export function useAddQuizQuestion(): AddHookResponse<QuizQuestionAddInput, QuizQuestionData> {
  const mutation = useTantalimMutation<QuizQuestionAddInput, QuizQuestionAddSuccess>({
    url: '/quiz/question/add',
  })

  const cache = useQuizCache()

  async function add(input: QuizQuestionAddInput): Promise<QuizQuestionData> {
    try {
      const { question } = await mutation.mutateAsync(input)
      cache.clearItem(question.quizId)
      return question
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
